var map = {
	"./CustomerRelations/CustomerFeedbackRatings": [
		807,
		0,
		1,
		5
	],
	"./CustomerRelations/CustomerFeedbackRatings.jsx": [
		807,
		0,
		1,
		5
	],
	"./CustomerRelations/LatestReviews": [
		808,
		15
	],
	"./CustomerRelations/LatestReviews.jsx": [
		808,
		15
	],
	"./CustomerRelations/ServiceRatingsReviews": [
		809,
		14
	],
	"./CustomerRelations/ServiceRatingsReviews.jsx": [
		809,
		14
	],
	"./FaveDealsInsights/RedemptionHourly": [
		810,
		0,
		2,
		18
	],
	"./FaveDealsInsights/RedemptionHourly.jsx": [
		810,
		0,
		2,
		18
	],
	"./FaveDealsInsights/UnlockMore": [
		804,
		17
	],
	"./FaveDealsInsights/UnlockMore.jsx": [
		804,
		17
	],
	"./FaveDealsView/DealsPerformanceBreakdown": [
		811,
		3
	],
	"./FaveDealsView/DealsPerformanceBreakdown.jsx": [
		811,
		3
	],
	"./FaveDealsView/FaveDealsOverview": [
		812,
		7
	],
	"./FaveDealsView/FaveDealsOverview.jsx": [
		812,
		7
	],
	"./FaveInsights/AverageSalesByAgeAndGender": [
		813,
		0,
		1,
		2,
		6
	],
	"./FaveInsights/AverageSalesByAgeAndGender.jsx": [
		813,
		0,
		1,
		2,
		6
	],
	"./FaveInsights/CustomerBreakdownByWeekAndType": [
		805,
		0,
		10
	],
	"./FaveInsights/CustomerBreakdownByWeekAndType.jsx": [
		805,
		0,
		10
	],
	"./FaveInsights/NewAndCurrentCustomer": [
		814,
		0,
		1,
		11
	],
	"./FaveInsights/NewAndCurrentCustomer.jsx": [
		814,
		0,
		1,
		11
	],
	"./FaveInsights/NoOfCustomersAgainstSimilarMerchants": [
		815,
		0,
		12
	],
	"./FaveInsights/NoOfCustomersAgainstSimilarMerchants.jsx": [
		815,
		0,
		12
	],
	"./FaveInsights/TotalSalesByAgeAndGender": [
		816,
		16
	],
	"./FaveInsights/TotalSalesByAgeAndGender.jsx": [
		816,
		16
	],
	"./FaveInsights/TotalSalesPerformanceBenchmark": [
		817,
		0,
		13
	],
	"./FaveInsights/TotalSalesPerformanceBenchmark.jsx": [
		817,
		0,
		13
	],
	"./FavePayView/CustomersByHourOfDay": [
		818,
		25
	],
	"./FavePayView/CustomersByHourOfDay.jsx": [
		818,
		25
	],
	"./FavePayView/FavePayOverview": [
		819,
		8
	],
	"./FavePayView/FavePayOverview.jsx": [
		819,
		8
	],
	"./FavePayView/OutletDetailedPerformance": [
		820,
		4
	],
	"./FavePayView/OutletDetailedPerformance.jsx": [
		820,
		4
	],
	"./FavePayView/WeekdaySalesCustomers": [
		821,
		0,
		2,
		24
	],
	"./FavePayView/WeekdaySalesCustomers.jsx": [
		821,
		0,
		2,
		24
	],
	"./Insights/BreakdownOfPaymentMethod": [
		822,
		0,
		1,
		22
	],
	"./Insights/BreakdownOfPaymentMethod.jsx": [
		822,
		0,
		1,
		22
	],
	"./Insights/BreakdownOfSales": [
		823,
		0,
		1,
		23
	],
	"./Insights/BreakdownOfSales.jsx": [
		823,
		0,
		1,
		23
	],
	"./Insights/CustomerTrends": [
		824,
		9
	],
	"./Insights/CustomerTrends.jsx": [
		824,
		9
	],
	"./Insights/DailySales": [
		825,
		0,
		2,
		20
	],
	"./Insights/DailySales.jsx": [
		825,
		0,
		2,
		20
	],
	"./Insights/MarketingCampaigns": [
		826,
		19
	],
	"./Insights/MarketingCampaigns.jsx": [
		826,
		19
	],
	"./Insights/TotalSales": [
		806,
		26
	],
	"./Insights/TotalSales.jsx": [
		806,
		26
	],
	"./InsightsStatic": [
		358
	],
	"./InsightsStatic.jsx": [
		358
	],
	"./MoreServices": [
		361
	],
	"./MoreServices.jsx": [
		361
	],
	"./PromotionalCard": [
		827,
		21
	],
	"./PromotionalCard.jsx": [
		827,
		21
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1278;
module.exports = webpackAsyncContext;